<template>
<div>
<event/>

</div>
</template>

<script>
import event from "../../components/Event/event.vue";


export default {
  components: {
   event
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>